var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { Toast } from "@/composables/toast";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import { wait } from "@/utils/utils";
/**
 * Generate a BioCompute Object from an invocation and send it to a BCODB server.
 * @param invocationId The ID of the invocation to export.
 * @param inputData The data needed to send the BCO to the BCODB.
 */
export function saveInvocationBCOToDatabase(invocationId, inputData) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const bcoContent = yield generateBcoContent(invocationId);
            yield sendBco(bcoContent, inputData);
            Toast.success(`Invocation successfully sent to: ${inputData.serverBaseUrl}`);
        }
        catch (err) {
            Toast.error(errorMessageAsString(err), "Error sending BioCompute Object to BCODB");
        }
    });
}
function generateBcoContent(invocationId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = {
            model_store_format: "bco.json",
            include_files: false,
            include_deleted: false,
            include_hidden: false,
        };
        const response = yield axios.post(withPrefix(`/api/invocations/${invocationId}/prepare_store_download`), data);
        const storage_request_id = response.data.storage_request_id;
        const pollUrl = withPrefix(`/api/short_term_storage/${storage_request_id}/ready`);
        const resultUrl = withPrefix(`/api/short_term_storage/${storage_request_id}`);
        let pollingResponse = yield axios.get(pollUrl);
        let maxRetries = 120;
        while (!pollingResponse.data && maxRetries) {
            yield wait(2000);
            pollingResponse = yield axios.get(pollUrl);
            maxRetries -= 1;
        }
        if (!pollingResponse.data) {
            throw Error("Timeout waiting for BioCompute Object export result!");
        }
        else {
            const resultResponse = yield axios.get(resultUrl);
            return resultResponse.data;
        }
    });
}
function sendBco(bcoContent, inputData) {
    return __awaiter(this, void 0, void 0, function* () {
        const bcoData = {
            POST_api_objects_draft_create: [
                {
                    contents: bcoContent,
                    owner_group: inputData.ownerGroup,
                    schema: "IEEE",
                    prefix: inputData.table,
                },
            ],
        };
        const headers = {
            Authorization: "Token " + inputData.authorization,
            "Content-type": "application/json; charset=UTF-8",
        };
        yield axios.post(`${inputData.serverBaseUrl}/api/objects/drafts/create/`, bcoData, { headers: headers });
    });
}
